import { Button } from "antd";
import LineSpacer from "../../../../../../../components/LineSpacer";
import { PlusOutlined } from "@ant-design/icons";
import { WplywContext } from "../../../../../../../context/wplywContext";
import { useContext } from "react";
import ReckoningsTransfers from "./ReckoningTransfers";
import Transfer from "./Transfer";

const InnerStage3 = (props) => {
	const { selectedPerson, deepLink } = props;
	const { wplyw, setWplyw } = useContext(WplywContext);

	return (
		<>
			{selectedPerson.msr_transfers.map((x, i) => (
				<Transfer
					transfer={x}
					selectedPerson={selectedPerson}
					index={i}
					deepLink={deepLink}
				/>
			))}
		</>
	);
};

export default InnerStage3;
